var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"fullscreen":"","value":_vm.value,"persistent":""}},[_c('chat-block',{attrs:{"number":_vm.value ? _vm.number : ''},on:{"close":function($event){return _vm.$emit('input')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }